// Prefixes
export const STATE_PREFIX = "sde-state-";

// Helper
export const TOUCH = "sde-h-touch";
export const NO_TOUCH = "sde-h-no-touch";
export const INVERTED = "sde-h-inverted";

// States
export const ACTIVE = "sde-state-active";
export const LOADING = "sde-state-loading";
export const INITIALIZING = "sde-state-initializing";
export const OPEN = "sde-state-open";
export const LOCKED = "sde-state-locked";
export const CLOSING = "sde-state-closing";
export const LOADED = "sde-state-loaded";
export const ERROR = "sde-state-error";
export const WARNING = "sde-state-warning";
export const HIDDEN = "sde-state-hidden";
export const VISIBLE = "sde-state-visible";
export const INVISIBLE = "sde-state-invisible";
export const INACTIVE = "sde-state-inactive";
export const VALID = "sde-state-valid";
export const UNSTARTED = "sde-state-unstarted";
export const ANIMATE = "sde-state-animate";
export const NO_ANIMATION = "sde-state-no-animation";
export const ANIMATING = "sde-state-animating";
export const IN_VIEWPORT = "sde-state-invp";
export const DRAGGING = "sde-state-dragging";
export const SCROLLING = "sde-state-scrolling";
export const MINIMAL = "sde-state-minimal";
export const UP = "sde-state-up";
export const DOWN = "sde-state-down";
export const DISABLED = "sde-state-disabled";
export const SELECTED = "sde-state-selected";
export const CAN_SUBMIT = "sde-state-can-submit";
export const HAS_OVERFLOW = "sde-state-has-overflow";
export const HASCOOKIE = "sde-state-has-cookie";
export const INITIALIZED = "sde-state-initialized";
export const OVERLAY_OPEN = "sde-state-overlay-open";
export const SUCCESS = "sde-state-success";
export const PLAYING = "sde-state-playing";
export const FINISHED = "sde-state-finished";
export const FILTERED = "sde-state-filtered";
export const EVEN = "sde-state-even";
export const STICKY = "sde-state-sticky";
export const KEYBOARD_FOCUS = "sde-h-keyboard-focus";
export const FOCUS = "sde-state-focus";
export const CAN_SCROLL_RIGHT = "sde-state-can-scroll-right";
export const CAN_SCROLL_LEFT = "sde-state-can-scroll-left";
export const CAN_SCROLL_UP = "sde-state-can-scroll-up";
export const CAN_SCROLL_DOWN = "sde-state-can-scroll-down";
export const HIDDEN_HEADER = "sde-state-hidden-header";
export const FOOTER_VISIBLE = "sde-state-footer-visible";
export const CUSTOMER_MODE_B2B = "sde-customer-mode-b2b";
export const CUSTOMER_MODE_B2C = "sde-customer-mode-b2c";
